import React, { Component } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import ResidencesList from './ResidencesList'
import NewResidenceForm from "./NewResidenceForm"

class ResidencesContainer extends Component {
	render() {
		return(
			<div className="ResidencesContainer">
				{this.renderResidences()}
				{this.renderNewResidenceForm()}
			</div>
		)
	}

	renderResidences = () => {
		let { t } = this.context

		if (this.props.residences && this.props.residences.length > 0) {
			return [
				<div key={0} className="list-title">{t('addresses')}</div>,
				<ResidencesList key={1}
								residences={this.props.residences}
								onResidenceSelected={this.props.onResidenceSelected}
								onEditClick={this.props.onEditResidence}
								onDeleteClick={this.props.onDeleteResidence}
				/>,
				<div className="divider" key={2}/>
			]
		}

		return null
	}

	renderNewResidenceForm = () => {
		let { t } = this.context

		let title = this.props.residences && this.props.residences.length > 0 ?
			<div key={3} className="form-title">{t('booking_flow_residence_selection_new_residence_title')}</div> : null

		return [
			title,
			<NewResidenceForm key={4}
							  residenceSuggestion={this.props.residenceSuggestion}
			/>
		]
	}
}

ResidencesContainer.contextTypes = { t: PropTypes.func }
const mapStateToProps = state => ({
	newResidence: state.dataReducer.residences.newResidence
})
export default connect(mapStateToProps)(ResidencesContainer);


// WEBPACK FOOTER //
// ./src/components/shared/ResidencesContainer.js